import { isString } from 'lodash';

export const objectToJson = (object: object) => {
  // Return the strigified object without new lines or return characters
  return JSON.stringify(object).replace(/(?:\\[rn])+/g, '');
};

export const jsonToObject = (json: string) => {
  let parsedJson = JSON.parse(json);

  // Overstringified JSON strings need to be parsed twice
  if (isString(parsedJson)) {
    parsedJson = JSON.parse(parsedJson);
  }

  return parsedJson;
};
